import { Activity, LogOut, Radio } from "lucide-react";

const Kpi = ({ label, value, unit }) => (
  <div className="ck-kpi">
    <div className="ck-kpi__label">{label}</div>
    <div className={"ck-kpi__val" + (value == null ? " nd" : "")}>
      {value == null ? "NO DATA" : `${value}${unit || ""}`}
    </div>
  </div>
);

// Barre de télémétrie supérieure : KPIs essentiels + état vivant TULUSS/VORTEX/Galaxy/Fabric.
export default function TelemetryBar({ perf, meta, live, windowHours, onLogout, mode, onMode }) {
  const d = perf?.decisions || {};
  const m = perf?.missions || {};
  const s = perf?.savings || {};
  const fabric = meta?.fabric;
  const liveCount = live?.count;
  const activeRes = (live?.resources || []).filter((r) => r.current_mission).length;

  return (
    <header className="ck-top" data-testid="ck-telemetry">
      <div className="ck-brand">
        <h1>TULUSS · SUPERCOCKPIT</h1>
        <span>Founder Command Center</span>
      </div>

      <div className="ck-kpis" data-testid="ck-kpis">
        <Kpi label={`Décisions ${windowHours}h`} value={d.count} />
        <Kpi label="Missions créées" value={m.created} />
        <Kpi label="Missions affectées" value={m.assigned} />
        <Kpi label="Km planifiés" value={d.planned_km} unit=" km" />
        <Kpi label="Km réels" value={d.actual_km} unit=" km" />
        <Kpi label="Km économisés" value={s.km_saved_estimated} unit=" km" />
        <Kpi label="Km à vide" value={s.empty_return_km} unit=" km" />
      </div>

      <div className="ck-sys">
        <div className="ck-mode" data-testid="ck-mode-toggle">
          <button className={mode === "ops" ? "on" : ""} onClick={() => onMode("ops")} data-testid="mode-ops">Pilotage</button>
          <button className={mode === "lab" ? "on" : ""} onClick={() => onMode("lab")} data-testid="mode-lab">Laboratoire</button>
        </div>
        <span className="ck-chip" title="Ressources GPS vivantes" data-testid="ck-sys-fleet">
          <Radio size={13} className="pulse" style={{ color: "#34d399", borderRadius: "50%" }} />
          <b style={{ color: "#eaf2fb" }}>{liveCount == null ? "—" : liveCount}</b> flotte · {activeRes} en mission
        </span>
        <span className="ck-chip" title="Systèmes Fabric LIVE" data-testid="ck-sys-fabric">
          <Activity size={13} style={{ color: fabric?.live_count ? "#22d3ee" : "#778698" }} />
          Fabric {fabric ? `${fabric.live_count ?? 0}/${fabric.total ?? 0}` : "—"}
        </span>
        <span className="ck-chip" title="Ressources Galaxy">
          Galaxy {meta?.galaxy?.resources?.length ?? "—"}
        </span>
        <button className="ck-logout" onClick={onLogout} data-testid="btn-logout-root">
          <LogOut size={13} style={{ verticalAlign: "-2px", marginRight: 5 }} />Fermer session Root
        </button>
      </div>
    </header>
  );
}
